import { FileService } from '../../services/fileApiService';
import { FoldersService } from '../../services/foldersApiService';
import { FunctionService } from '../../services/functionService';

/** Shared `FileService` instance for file CRUD, sharing, AI, and related API calls in this feature. */
export const fileService = new FileService();

/** Shared `FoldersService` instance used by password and folder flows under `useFilesActions`. */
export const foldersService = new FoldersService();

/** Shared `FunctionService` instance for server-side function invocations from password actions. */
export const functionService = new FunctionService();
